import React from "react";
import Button from "../Button/Button";
import { BiSupport } from "react-icons/bi";

const Cta = () => {
  return (
    <section className="cta">
      <div className="container">
        <div className="cta-container">
          <div className="row align-items-center justify-content-between">
            <div className="col-6">
              <div className="cta-content">
                <div className="cta-icon">
                  <BiSupport />
                </div>
                <div className="cta-txt">
                  <h3>Parla con un tecnico</h3>
                  <p>
                    Un nostro esperto è pronto a rispondere alle tue domande e
                    consigliarti la soluzione migliore per le tue esigenze.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-6 text-right">
              <Button testo="Contattaci" link="/contattaci" stile="1" />
              <Button testo="Tutti i servizi" link="/servizi" stile="2" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cta;
